// Pricing + itinerary computation shared across builder & review

export function itemPrice(item, modulesById, serviceLevel) {
  if (item.kind === "transport") return item.price || 0;
  const m = modulesById[item.module_id];
  if (!m) return 0;
  const level = item.service_override || serviceLevel;
  return m.prices[level] ?? m.prices.comfort ?? 0;
}

export function itemDays(item, modulesById) {
  if (item.kind === "transport") return item.days || 0;
  const m = modulesById[item.module_id];
  return m ? m.days : 0;
}

export function computeJourney(items, modulesById, serviceLevel, travellers = 2) {
  let perPerson = 0;
  let duration = 0;
  const breakdown = {};
  items.forEach((it) => {
    const p = itemPrice(it, modulesById, serviceLevel);
    perPerson += p;
    duration += itemDays(it, modulesById);
    const cat = it.kind === "transport" ? "Transport" : catLabel(modulesById[it.module_id]?.type);
    breakdown[cat] = (breakdown[cat] || 0) + p;
  });
  const total = perPerson * travellers;
  const deposit = Math.round(total * 0.2);
  return { perPerson, total, deposit, duration, breakdown };
}

function catLabel(type) {
  const map = {
    trekking: "Trekking & Experiences", trek: "Trekking & Experiences",
    culture: "Culture & Heritage", heritage: "Culture & Heritage",
    accommodation: "Accommodation", wellness: "Wellness",
    wildlife: "Wildlife", adventure: "Adventure",
  };
  return map[type] || "Experiences";
}

// build a chronological day-by-day list
export function buildTimeline(items, modulesById, locationsById) {
  let day = 1;
  return items.map((it) => {
    if (it.kind === "transport") {
      const start = day;
      const d = it.days || 0;
      const range = d > 0 ? `${start}` : `${start}`;
      day += d;
      return {
        key: it.uid,
        item: it,
        dayRange: range,
        location: it.label || "Transfer",
        title: it.label || "Transfer",
        type: "transport",
      };
    }
    const m = modulesById[it.module_id];
    const start = day;
    const end = day + (m?.days || 1) - 1;
    day = end + 1;
    const loc = locationsById[m?.location_id];
    return {
      key: it.uid,
      item: it,
      dayRange: start === end ? `${start}` : `${start}-${end}`,
      location: loc?.name || "",
      title: m?.name || "",
      type: m?.type,
      module: m,
    };
  });
}
